module.exports = __webpack_public_path__ + "static/media/koryu_00029Before.a9ef09ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/koryu_00029Before.png
// module id = 203
// module chunks = 0